// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file onboarding/upsert_medical_inventory.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Quantity } from "../inventory/common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.UpsertMedicalInventoryRequest
 */
export class UpsertMedicalInventoryRequest extends Message<UpsertMedicalInventoryRequest> {
  /**
   * @generated from field: string medical_master_id = 1;
   */
  medicalMasterId = "";

  /**
   * @generated from field: com.neulink.pharmacy.Quantity quantity = 2;
   */
  quantity?: Quantity;

  /**
   * @generated from field: string batch_number = 3;
   */
  batchNumber = "";

  /**
   * @generated from field: string expiry_date = 4;
   */
  expiryDate = "";

  /**
   * @generated from field: double cost = 5;
   */
  cost = 0;

  /**
   * @generated from field: optional string production_date = 6;
   */
  productionDate?: string;

  constructor(data?: PartialMessage<UpsertMedicalInventoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpsertMedicalInventoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "medical_master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "message", T: Quantity },
    { no: 3, name: "batch_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "expiry_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "cost", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "production_date", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpsertMedicalInventoryRequest {
    return new UpsertMedicalInventoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpsertMedicalInventoryRequest {
    return new UpsertMedicalInventoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpsertMedicalInventoryRequest {
    return new UpsertMedicalInventoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpsertMedicalInventoryRequest | PlainMessage<UpsertMedicalInventoryRequest> | undefined, b: UpsertMedicalInventoryRequest | PlainMessage<UpsertMedicalInventoryRequest> | undefined): boolean {
    return proto3.util.equals(UpsertMedicalInventoryRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.UpsertMedicalInventoryResponse
 */
export class UpsertMedicalInventoryResponse extends Message<UpsertMedicalInventoryResponse> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string created_at = 2;
   */
  createdAt = "";

  constructor(data?: PartialMessage<UpsertMedicalInventoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.UpsertMedicalInventoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "created_at", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpsertMedicalInventoryResponse {
    return new UpsertMedicalInventoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpsertMedicalInventoryResponse {
    return new UpsertMedicalInventoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpsertMedicalInventoryResponse {
    return new UpsertMedicalInventoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpsertMedicalInventoryResponse | PlainMessage<UpsertMedicalInventoryResponse> | undefined, b: UpsertMedicalInventoryResponse | PlainMessage<UpsertMedicalInventoryResponse> | undefined): boolean {
    return proto3.util.equals(UpsertMedicalInventoryResponse, a, b);
  }
}

